/*!
 * KoliBri - The accessible HTML-Standard
 */
import { h, F as Fragment } from './index-C_ZKddLG.js';
import { t as translate } from './i18n-CvFPh0g5.js';

function renderSpinVariant(variant) {
    switch (variant) {
        case 'cycle':
            return h("span", { class: `kol-spin__loader kol-spin__spinner--${variant}__element` });
        case 'none':
            return h("slot", { name: "expert" });
        default:
            return (h(Fragment, null, h("span", { class: `kol-spin__spinner-element
							kol-spin__spinner-element--1
							kol-spin__spinner--${variant}__element
							kol-spin__spinner--${variant}__element--1` }), h("span", { class: `kol-spin__spinner-element
							kol-spin__spinner-element--2
							kol-spin__spinner--${variant}__element
							kol-spin__spinner--${variant}__element--2` }), h("span", { class: `kol-spin__spinner-element
							kol-spin__spinner-element--3
							kol-spin__spinner--${variant}__element
							kol-spin__spinner--${variant}__element--3` }), h("span", { class: `kol-spin__spinner-element
							kol-spin__spinner-element--neutral
							kol-spin__spinner--${variant}__element
							kol-spin__spinner--${variant}__element--4` })));
    }
}
const SpinFC = (props) => {
    const { show, label, variant } = props;
    return (h(Fragment, null, show ? (h(Fragment, null, h("span", { class: `kol-spin__spinner kol-spin__spinner--${variant}` }, renderSpinVariant(variant)), h("span", { "aria-busy": "true", class: "visually-hidden", role: "alert" }, label || translate('kol-action-running')))) : (h("span", { "aria-busy": "false", class: "visually-hidden", role: "alert" }, label || translate('kol-action-done')))));
};

export { SpinFC as S };
//# sourceMappingURL=component-K3ngYLGq.js.map

//# sourceMappingURL=component-K3ngYLGq.js.map